import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import { createReducer } from './utils';

import { getRolesSelector } from './roles';
import { getLockingsWithoutRootSelector } from './lockings';

import * as ActionTypes from '../app/ActionTypes';

/*
	Reducer cases
*/

function getCylindersTypesSuccess(state, action) {
	return action.result;
}

function roleClick(state, action) {
	return action.roleId;
}

function saveRoleSuccess(state, action) {
	return 0;
}

/*
	Reducer
*/

const cylindersTypesInitialState = {
	DE: { dimension_a: { min: 0, max: 0 }, dimension_b: { min: 0, max: 0 } },
	BT: { dimension_a: { min: 0, max: 0 }, dimension_b: { min: 0, max: 0 } },
	'1/2': { dimension_a: { min: 0, max: 0 }, dimension_b: { min: 0, max: 0 } },
	'DE+D': {
		dimension_a: { min: 0, max: 0 },
		dimension_b: { min: 0, max: 0 }
	},
	'BT+D': { dimension_a: { min: 0, max: 0 }, dimension_b: { min: 0, max: 0 } }
};

const cylindersTypes = createReducer(cylindersTypesInitialState, {
	[ActionTypes.GET_CYLINDERS_TYPES_SUCCESS]: getCylindersTypesSuccess
});

const activeRoleId = createReducer(null, {
	[ActionTypes.NEW_ROLE]: (state, action) => null,
	[ActionTypes.ROLE_CLICK]: (state, action) => action.roleId,
	[ActionTypes.CLOSE_ROLE_FORM]: (state, action) => null,
	[ActionTypes.SAVE_ROLE_SUCCESS]: (state, action) => null
});

const isRoleFormOpen = createReducer(false, {
	[ActionTypes.NEW_ROLE]: (state, action) => true,
	[ActionTypes.ROLE_CLICK]: (state, action) =>
		action.roleId === 0 ? false : true,
	[ActionTypes.CLOSE_ROLE_FORM]: (state, action) => false,
	[ActionTypes.SAVE_ROLE_SUCCESS]: (state, action) => false,
	[ActionTypes.DELETE_ROLE_REQUEST]: (state, action) => false
});

const loadingProject = createReducer(false, {
	[ActionTypes.GET_PROJECT_REQUEST]: (state, action) => true,
	[ActionTypes.GET_PROJECT_SUCCESS]: (state, action) => false
});

const loadingRoles = createReducer(false, {
	[ActionTypes.GET_ROLE_REQUEST]: (state, action) => true,
	[ActionTypes.GET_ROLE_SUCCESS]: (state, action) => false
});

const loadingLockings = createReducer(false, {
	[ActionTypes.GET_LOCKINGS_REQUEST]: (state, action) => true,
	[ActionTypes.GET_LOCKINGS_SUCCESS]: (state, action) => false
});

const loadingCylinderTypes = createReducer(false, {
	[ActionTypes.GET_CYLINDERS_TYPES_REQUEST]: (state, action) => true,
	[ActionTypes.GET_CYLINDERS_TYPES_SUCCESS]: (state, action) => false
});

/*
	Selectors
*/

const MIN_COLS_NUMBER = 20;
const MIN_ROWS_NUMBER = 25;

const getExtraColsNumberSelector = createSelector(getRolesSelector, roles => {
	const isEnough = roles.length < MIN_COLS_NUMBER;
	if (isEnough) {
		const emptyColsNumber = MIN_COLS_NUMBER - roles.length;
		return emptyColsNumber;
	}
	return 3;
});

const getExtraRowsNumberSelector = createSelector(
	getLockingsWithoutRootSelector,
	lockings => {
		const isEnough = lockings.length > MIN_ROWS_NUMBER;
		if (!isEnough) {
			const emptyRowsNumber = MIN_ROWS_NUMBER - lockings.length;
			return emptyRowsNumber;
		}
		return 3;
	}
);

const getCylindersTypesSelector = state => state.app.cylindersTypes;

const getIsRoleFormOpenSelector = state => state.app.isRoleFormOpen;

const getActiveRoleIdSelector = state => state.app.activeRoleId;

const getLoadingProjectSelector = state => state.app.loadingProject;

const getLoadingRolesSelector = state => state.app.loadingRoles;

const getLoadingLockingsSelector = state => state.app.loadingLockings;

const getLoadingCylinderTypesSelector = state => state.app.loadingCylinderTypes;

const getRolesToDuplicate = state => state.app.rolesToDuplicate;

import isRetrievingUser from './app/isRetrievingUser';
import duplication from './app/duplication';
import lockingForm from './app/lockingForm';
import activeLockingId from './app/activeLockingId';
import collapsedGroups from './app/collapsedGroups';
import dialog from './app/dialog';
import toast from './app/toast';

const reducer = combineReducers({
	isRetrievingUser,
	activeLockingId,
	lockingForm,
	collapsedGroups,
	duplication,
	dialog,
	toast,

	cylindersTypes,
	isRoleFormOpen,
	activeRoleId,
	loadingProject,
	loadingRoles,
	loadingLockings,
	loadingCylinderTypes
});

export default reducer;
export {
	getCylindersTypesSelector,
	getExtraColsNumberSelector,
	getExtraRowsNumberSelector,
	getIsRoleFormOpenSelector,
	getActiveRoleIdSelector,
	getLoadingProjectSelector,
	getLoadingRolesSelector,
	getLoadingLockingsSelector,
	getLoadingCylinderTypesSelector,
	getRolesToDuplicate
};



// WEBPACK FOOTER //
// ./src/js/reducers/app.js